/*jshint esversion: 6 */
$.fn.toggleAttr = function (attr, attr1, attr2) {

    return $(this).each(function () {
        const self = $(this);
        if (self.attr(attr) === attr1)
            self.attr(attr, attr2);
        else
            self.attr(attr, attr1);
    });
}

if (typeof jQuery !== 'undefined') {
    // console.log('jQuery is loaded!');    
} else {
    console.log('jQuery is not loaded!');
}

var UploadAdapter = UploadAdapter || {};

(function ($) {
    "use strict";

    UploadAdapter.data = {
        csrf: $('meta[name="csrf-token"]').attr('content'),
        url: $('meta[name="base-url"]').attr('content'),
    }

    UploadAdapter.local = {
        file_selected: "file selected",
        files_selected: "files selected",
        choose_file: "Choose file",
    }

    UploadAdapter.uploader = {
        data: {
            selectedFiles: [],
            selectedFilesObject: [],
            clickedForRemove: null,
            allFiles: [],
            multiple: false,
            type: 'all',
            next_page_url: null,
            prev_page_url: null,
        },
        initForInput: function () {
            $(document).on('click', '[data-toggle="uploader"]', function (e) {
                if (e.detail === 1) {
                    var element = $(this);

                    var multiple = element.data('multiple');
                    var type = element.data('type');
                    var oldSelectedFiles = element.closest('.card').find('.card-body').find(".selected-files").val();

                    multiple = !multiple ? "" : multiple;
                    type = !type ? "" : type;
                    oldSelectedFiles = !oldSelectedFiles ? "" : oldSelectedFiles;

                    UploadAdapter.uploader.trigger(this, "input", type, oldSelectedFiles, multiple);
                }
            });
        },
        trigger: function (elem = null, from = "", type = "all", selected = "", multiple = false, callback = null) {

            var element = $(elem);
            var multiple = multiple;
            var type = type;
            var oldSelectedFiles = selected;

            console.log(oldSelectedFiles)
            if (oldSelectedFiles !== "" && typeof JSON.parse(oldSelectedFiles) === 'object') {
                UploadAdapter.uploader.data.selectedFiles = JSON.stringify(JSON.parse(oldSelectedFiles).map((item, key) => {
                    return {id: item.id, sequence: key};
                }));
            } else {

                UploadAdapter.uploader.data.selectedFiles = [];
            }

            if ("undefined" !== typeof type && type.length > 0) {
                UploadAdapter.uploader.data.type = type;
            }

            if (multiple) {
                UploadAdapter.uploader.data.multiple = multiple;
            }

            $.post(UploadAdapter.data.url + "/asset/assets/modal", {
                _token: UploadAdapter.data.csrf,
            }, function (data) {
                $("body").append(data);
                $("#aizUploaderModal").modal("show");
                UploadAdapter.plugins.dropZone();

                UploadAdapter.uploader.getAllUploads(
                    UploadAdapter.data.url + "/asset/assets/all",
                    null,
                    $('[name="aiz-uploader-sort"]').val()
                );
                UploadAdapter.uploader.updateUploaderFiles();
                UploadAdapter.uploader.searchUploaderFiles();
                UploadAdapter.uploader.sortUploaderFiles();
                UploadAdapter.uploader.showSelectedFiles();
                UploadAdapter.uploader.dismissUploader();

                $("#uploader_prev_btn").on("click", function () {
                    if (UploadAdapter.uploader.data.prev_page_url != null) {
                        $('[name="aiz-show-selected"]').prop(
                            "checked",
                            false
                        );
                        UploadAdapter.uploader.getAllUploads(
                            UploadAdapter.uploader.data.prev_page_url
                        );
                    }
                });

                $("#uploader_next_btn").on("click", function () {
                    if (UploadAdapter.uploader.data.next_page_url != null) {
                        $('[name="aiz-show-selected"]').prop(
                            "checked",
                            false
                        );
                        UploadAdapter.uploader.getAllUploads(
                            UploadAdapter.uploader.data.next_page_url
                        );
                    }
                });

                $('[data-toggle="aizUploaderAddSelected"]').on("click", function () {

                    console.log('files', UploadAdapter.uploader)
                        if (from === "input") {
                            UploadAdapter.uploader.inputSelectPreviewGenerate(element);
                        } else if (from === "direct") {
                            callback(UploadAdapter.uploader.data.selectedFiles);
                        }
                        $("#aizUploaderModal").modal("hide");
                    }
                );
            });

        },
        getAllUploads: function (url, search = null, sort_key = null) {

            var params = {};
            if (search !== null && search.length > 0) {
                params["search"] = search;
            }
            if (sort_key != null && sort_key.length > 0) {
                params["sort"] = sort_key;
            } else {
                params["sort"] = 'newest';
            }

            $.get(url, params, function (data) {
                UploadAdapter.uploader.data.allFiles = data.data.data;

                UploadAdapter.uploader.addSelectedValue();
                UploadAdapter.uploader.updateUploaderFiles();

                if (data.data.next_page_url != null) {
                    UploadAdapter.uploader.data.next_page_url = data.data.next_page_url;
                    $("#uploader_next_btn").removeAttr("disabled");
                } else {
                    $("#uploader_next_btn").attr("disabled", true);
                }
                if (data.data.prev_page_url != null) {
                    UploadAdapter.uploader.data.prev_page_url = data.data.prev_page_url;
                    $("#uploader_prev_btn").removeAttr("disabled");
                } else {
                    $("#uploader_prev_btn").attr("disabled", true);
                }
            });
        },
        updateUploaderFiles: function () {
            var data = UploadAdapter.uploader.data.allFiles;
            console.log(data);
            //set time out for modal to load with images
            setTimeout(function () {

                //empty the container to append new images
                $('.aiz-uploader-all').html(null);

                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        var thumbnail = "";
                        var extension = data[i].orgfname.split('.').pop().toLowerCase();

                        if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'webp') {

                            thumbnail =
                                '<img src="' +
                                data[i].file_url +
                                '" class="img-thumbnail" alt="' + data[i].orgfname + '" >';
                        } else {
                            thumbnail = '<i class="fa fa-file"></i>';
                        }

                        var html =
                            '<div class="aiz-file-box-wrap" data-selected="' +
                            data[i].selected +
                            '">' +
                            '<div class="aiz-file-box">' +
                            '<div class="card card-file aiz-uploader-select" title="' +
                            data[i].orgfname +
                            "." +
                            extension +
                            '" data-value="' +
                            data[i].id +
                            '">' +
                            '<div class="card-file-thumb">' +
                            thumbnail +
                            "</div>" +
                            '<div class="card-body">' +
                            '<h6 class="d-flex">' +
                            '<span class="text-truncate title">' +
                            data[i].orgfname +
                            "</span>" +
                            '<span class="ext flex-shrink-0">.' +
                            extension +
                            "</span>" +
                            "</h6>" +
                            "</div>" +
                            "</div>" +
                            "</div>" +
                            "</div>";
                        $(".aiz-uploader-all").append(html);
                    }
                }

                UploadAdapter.uploader.uploadSelected();


            }, 300);
        },
        addSelectedValue: function () {

            for (let i = 0; i < UploadAdapter.uploader.data.allFiles.length; i++) {
                UploadAdapter.uploader.data.allFiles[i].selected = UploadAdapter.uploader.data.selectedFiles.includes(
                    UploadAdapter.uploader.data.allFiles[i].id
                );
            }
        },
        searchUploaderFiles: function () {
            $('[name="aiz-uploader-search"]').on('keyup', function () {
                var search = $(this).val();

                UploadAdapter.uploader.getAllUploads(
                    UploadAdapter.data.url + "/asset/assets/all",
                    search,
                    $('[name="aiz-uploader-sort"]').val()
                );
            });
        },
        sortUploaderFiles: function () {
            $('[name="aiz-uploader-sort"]').on("change", function () {
                var value = $(this).val();
                UploadAdapter.uploader.getAllUploads(
                    UploadAdapter.data.url + "/asset/assets/all",
                    $('[name="aiz-uploader-search"]').val(),
                    value
                );
            });
        },
        showSelectedFiles: function () {
            $('[name="aiz-show-selected"]').on("change", function () {

                if ($(this).is(":checked")) {
                    UploadAdapter.uploader.data.allFiles = UploadAdapter.uploader.data.allFiles.filter(
                        (file) => file.selected
                    );
                    UploadAdapter.uploader.updateUploaderFiles();
                } else {
                    UploadAdapter.uploader.getAllUploads(
                        UploadAdapter.data.url + "/asset/assets/all",
                        $('[name="aiz-uploader-search"]').val(),
                        $('[name="aiz-uploader-sort"]').val()
                    );
                }
            });
        },
        uploadSelected: function () {
            $(".aiz-uploader-select").each(function () {
                var elem = $(this);

                elem.on("click", function () {
                    var value = $(this).data("value");

                    console.log(value)
                    console.log(UploadAdapter.uploader.data.allFiles)

                    var valueObject = UploadAdapter.uploader.data.allFiles[UploadAdapter.uploader.data.allFiles.findIndex((x) => x.id === value)];


                    console.log('valueObject', valueObject)
                    console.log(UploadAdapter.uploader.data.allFiles)
                    elem.closest(".aiz-file-box-wrap").toggleAttr(
                        "data-selected",
                        "true",
                        "false"
                    );

                    if (!UploadAdapter.uploader.data.multiple) {
                        elem.closest(".aiz-file-box-wrap")
                            .siblings()
                            .attr("data-selected", "false");
                    }

                    console.log('type of', typeof UploadAdapter.uploader.data.selectedFiles)
                    var selectedFiles = UploadAdapter.uploader.data.selectedFiles;
                    if (typeof selectedFiles === "string") {

                        var selectedFilesArray = JSON.parse(selectedFiles);

                        if (!selectedFilesArray.some(item => item.id === value)) {
                            if (!UploadAdapter.uploader.data.multiple) {
                                UploadAdapter.uploader.data.selectedFiles = [];
                                UploadAdapter.uploader.data.selectedFilesObject = [];
                            }

                            const maxSequence = Math.max(...selectedFilesArray.map(item => item.sequence));

                            const selectedFilesObject = {"id": value, "sequence": maxSequence + 1};

                            selectedFilesArray.push(selectedFilesObject);

                            console.log('push', selectedFilesArray)
                            UploadAdapter.uploader.data.selectedFiles = JSON.stringify(selectedFilesArray);
                        } else {
                            selectedFilesArray = JSON.parse(UploadAdapter.uploader.data.selectedFiles).filter(function (item) {
                                return item.id !== value;
                            });
                            console.log('pop', selectedFilesArray)
                            UploadAdapter.uploader.data.selectedFiles = JSON.stringify(selectedFilesArray);
                        }
                    }

                    if (typeof selectedFiles === "object") {

                            if (!selectedFiles.some(item => item.id === value)) {
                                if (!UploadAdapter.uploader.data.multiple) {
                                    UploadAdapter.uploader.data.selectedFiles = [];
                                    UploadAdapter.uploader.data.selectedFilesObject = [];
                                }

                                // const maxSequence = Math.max(...selectedFiles.map(item => item.sequence));

                                const selectedFilesObject = {"id": value, "sequence": selectedFiles.length};

                                selectedFiles.push(selectedFilesObject);

                                console.log('push', selectedFiles)
                                UploadAdapter.uploader.data.selectedFiles = selectedFiles;
                            } else {
                                selectedFiles = UploadAdapter.uploader.data.selectedFiles.filter(function (item) {
                                    return item.id !== value;
                                });
                                console.log('pop', selectedFiles)
                                UploadAdapter.uploader.data.selectedFiles = selectedFiles;
                            }
                    }

                    console.log(selectedFiles)

                    UploadAdapter.uploader.addSelectedValue();
                });
            });
        },
        inputSelectPreviewGenerate: function (elem) {

            var card = elem.closest('.card');
            var cardBody = card.find('.card-body');

            console.log('selected-value', UploadAdapter.uploader.data.selectedFiles)
            console.log('type of ', typeof UploadAdapter.uploader.data.selectedFiles)

            cardBody.find(".selected-files")
                .val('');
            var selectedFiles = typeof UploadAdapter.uploader.data.selectedFiles !== 'object' ? JSON.parse(UploadAdapter.uploader.data.selectedFiles) : UploadAdapter.uploader.data.selectedFiles;
            var selectedFilesInput = cardBody.find(".selected-files")
                .val(typeof UploadAdapter.uploader.data.selectedFiles === 'object' ? JSON.stringify(UploadAdapter.uploader.data.selectedFiles) : UploadAdapter.uploader.data.selectedFiles);


            var ids = selectedFiles.map((item) => item.id)
            cardBody.find(".file-preview").html(null);

            if (selectedFiles.length > 0) {
                $.get(UploadAdapter.data.url + "/asset/assets/all",
                    {_token: UploadAdapter.data.csrf, ids: ids.toString()},
                    function (data) {

                        if (data.data.data.length > 0) {

                            for (var i = 0; i < data.data.data.length; i++) {
                                var thumbnail = "";

                                var extension = data.data.data[i].orgfname.split('.').pop().toLowerCase();

                                if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'webp') {
                                    
                                    thumbnail =
                                        '<img src="' + data.data.data[i].file_url +
                                        '" class="img-thumbnail" width="80" alt="' + data.data.data[i].orgfname + '" >';
                                } else {
                                    thumbnail = '<i class="fa fa-file"></i>';
                                }

                                var html = '<tr>' +
                                    '<td id="' + data.data.data[i].id + '">' +
                                    data.data.data[i].orgfname +
                                    '</td>' +
                                    '<td>' +
                                    thumbnail +
                                    '</td>' +
                                    '<td>' +
                                    '<div class="radio"><input type="radio" name="is_default" value="' + data.data.data[i].id + '" checked="checked"></div>' +
                                    '</td>' +
                                    '<td>' +
                                    '<div class="remove">' +
                                    '<button class="btn btn-sm btn-link remove-attachment btn-close" type="button">' +
                                    '<i class="fa fa-close"></i>' +
                                    '</button>' +
                                    '</div>' +
                                    '</td>' +
                                    '</tr>';

                                cardBody.find(".file-preview").append(html);
                            }
                        }
                    });
            }
        },
        previewGenerate: function () {
            $('[data-toggle="uploader"]').each(function () {

                var card = $(this).closest('.card');
                var cardBody = card.find('.card-body');
                var files = cardBody.find(".selected-files").val();
                var defaultPhoto = $('[name="is_default"]').val();

                if (files.length > 0) {
                    //format the string to array with proper index
                    const formattedArray = files.split(",").map(Number).map((item, key) => {
                        return {id: item, sequence: key};
                    });

                    cardBody.find(".selected-files").val(JSON.stringify(formattedArray))
                }


                if (files.length > 0) {
                    $.get(UploadAdapter.data.url + "/asset/assets/all",
                        {_token: UploadAdapter.data.csrf, ids: files},
                        function (data) {


                            if (data.data.data.length > 0) {

                                for (var i = 0; i < data.data.data.length; i++) {
                                    var thumbnail = "";

                                    var extension = data.data.data[i].orgfname.split('.').pop().toLowerCase();

                                    if (extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'webp') {
                                        
                                        thumbnail =
                                            '<img src="' + data.data.data[i].file_url +
                                            '" class="img-thumbnail" width="80" alt="' + data.data.data[i].orgfname + '" >';
                                    } else {
                                        thumbnail = '<i class="fa fa-file"></i>';
                                    }


                                    var selected = data.data.data[i].id == defaultPhoto ? 'checked="checked"' : '';

                                    var html = '<tr>' +
                                        '<td id="' + data.data.data[i].id + '">' +
                                        data.data.data[i].orgfname +
                                        '</td>' +
                                        '<td>' +
                                        thumbnail +
                                        '</td>' +
                                        '<td>' +
                                        '<div class="radio"><input type="radio" name="is_default" value="' + data.data.data[i].id + '" '+selected+'></div>' +
                                        '</td>' +
                                        '<td>' +
                                        '<div class="remove">' +
                                        '<button class="btn btn-sm btn-link remove-attachment btn-close" type="button">' +
                                        '<i class="fa fa-close"></i>' +
                                        '</button>' +
                                        '</div>' +
                                        '</td>' +
                                        '</tr>';

                                    cardBody.find(".file-preview").append(html);
                                }
                            }
                        });
                }

            });
        },
        dismissUploader: function () {
            $("#aizUploaderModal").on("hidden.bs.modal", function () {
                $(".aiz-uploader-backdrop").remove();
                $("#aizUploaderModal").remove();
            });
        },
        removeAttachment: function () {
            $(document).on("click", '.remove-attachment', function () {

                var value = $(this).closest('tr').find('td:first').attr('id')

                var selected = $(this)
                    .closest(".file-preview")
                    .closest('.card-body') // Use prevAll to find all preceding siblings matching the selector
                    .first() // Get the first matching sibling
                    .find(".selected-files")
                    .val();

                UploadAdapter.uploader.removeInputValue(
                    value,
                    selected,
                    $(this)
                        .closest(".file-preview")
                        .closest('.card-body')
                        .first()
                );

                $(this).closest("tr").remove();
            });
        },
        removeInputValue: function (id, array, elem) {

            array = typeof array !== 'object' ? JSON.parse(array) : array
            var selected = array.filter(function (item) {
                return item.id !== Number(id);
            });

            $(elem).find(".selected-files").val('');
            $(elem).find(".selected-files").val(JSON.stringify(selected));
        },

    }


    UploadAdapter.plugins = {
        dropZone: function () {
            var dropzone = new Dropzone("#aizUploaderModal .dropzone", {
                paramName: "file",
                maxFilesize: 20,
                url: UploadAdapter.data.url + "/asset/assets/store",
                headers: {
                    'X-CSRF-TOKEN': UploadAdapter.data.csrf
                },
                init: function () {
                    this.on('uploadprogress', function (file, progress, bytesSent) {
                        $(file.previewElement).find(".progress-bar").css("width", progress + "%");
                    });

                    this.on('success', function (file, response) {
                        this.removeAllFiles();
                        UploadAdapter.uploader.getAllUploads(UploadAdapter.data.url + "/asset/assets/all",)
                    });

                    this.on('error', function (file, errorMessage) {
                        console.error('File upload error:', errorMessage);
                        this.removeFile(file); // Remove only the failed file.
                    });
                }
            });
        }
    }

    UploadAdapter.uploader.initForInput()
    UploadAdapter.uploader.removeAttachment()
    UploadAdapter.uploader.previewGenerate()

})(jQuery);
